import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../shared.module';
import { RcsEditorComponent } from './rcs-editor/rcs-editor.component';
import { RcsGalleryModalComponent } from './rcs-gallery-modal/rcs-gallery-modal.component';
import { RcsMediaUploadComponent } from './rcs-media-upload/rcs-media-upload.component';
import { RcsNumberPipe } from './rcs-number.pipe';
import { RcsPhoneComponent } from './rcs-phone/rcs-phone.component';

/**
 * Peças do RCS usadas fora do módulo lazy `rcs`: o editor da mensagem entra no
 * envio em massa (lazy) e na etapa RCS da automação (no `PagesModule`, eager); o
 * celular da prévia (`app-rcs-phone`) é do editor e do relatório do envio.
 */
@NgModule({
  declarations: [
    RcsEditorComponent,
    RcsGalleryModalComponent,
    RcsMediaUploadComponent,
    RcsNumberPipe,
    RcsPhoneComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModalModule,
    SharedModule,
  ],
  exports: [
    RcsEditorComponent,
    RcsGalleryModalComponent,
    RcsMediaUploadComponent,
    RcsNumberPipe,
    RcsPhoneComponent,
  ],
})
export class RcsSharedModule {}
